import { Box, Button } from '@mui/material';
import { DataGrid, GridAddIcon, type GridColDef } from '@mui/x-data-grid';
import { Link, NavLink, Outlet, useLocation } from 'react-router';

import PageBaseLayout from '../layouts/PageBaseLayout';
import { useEffect, useState } from 'react';
import { supabase } from '../supabase-client';
import type { Merchant, MerchantTransaction } from '../models/types';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';
import useDialog from '../hooks/useDialog';
import BrandTransactionDialog from '../components/BrandTransactionDialog';

export default function TrandingBrandTransactions() {
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();
  const dialog = useDialog();
  const location = useLocation();

  const path = location.pathname;
  const match = path.match(/\/tranding-merchant-transactions\/(\d+)\b/);
  const merchantId = match ? match[1] : null;
  console.log(`merchid: ${merchantId}`);

  const [brandName, setBrandName] = useState<string>('');
  const [brandTransactions, setBrandTransactions] = useState<
    MerchantTransaction[]
  >([
    // {
    //   id: 1,
    //   merchant_id: 0,
    //   amount: 0,
    //   created_at: new Date().toISOString(),
    //   type: 'debit',
    //   reason_id: 'ABC123',
    //   remarks: '',
    // },
  ]);
  const columns: GridColDef<MerchantTransaction>[] = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
      // renderCell: (param) => (
      //   <Button
      //     fullWidth
      //     component={NavLink}
      //     to={`./${param.row.id}`}
      //     state={param.row}
      //     size="small"
      //     variant="outlined">
      //     {param.value}
      //   </Button>
      // ),
    },
    {
      field: 'merchant_id',
      headerName: 'Brand ID',
      width: 100,
      type: 'number',
      // renderCell: (param) => (
      //   <Button
      //     fullWidth
      //     component={NavLink}
      //     to={`./${param.row.id}`}
      //     state={param.row}
      //     size="small"
      //     variant="outlined">
      //     {param.value}
      //   </Button>
      // ),
    },
    {
      field: 'created_at',
      headerName: 'Created',
      type: 'dateTime',
      valueGetter: (value) => new Date(value),
      width: 180,
    },
    {
      field: 'type',
      headerName: 'Type',
      width: 100,
    },
    {
      field: 'reason_id',
      headerName: 'Reason ID',
      width: 180,
      type: 'string',
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 100,
      type: 'number',
      // renderCell: (param) => (
      //   <Box display="flex" alignItems="center" height="100%">
      //     <img src={param.value} height={40} />
      //   </Box>
      // ),
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 300,
      type: 'string',
    },
  ];

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      if (merchantId) {
        const [brandTransactionsResponse, brandNameResponse] =
          await Promise.all([
            supabase
              .schema('admin_backend')
              .from('brand_transactions')
              .select('*')
              .eq('merchant_id', merchantId)
              .order('created_at', { ascending: false }),
            supabase
              .schema('app')
              .from('merchants')
              .select('name')
              .eq('id', merchantId)
              .single(),
          ]);

        if (brandTransactionsResponse.error) {
          console.error(
            'Error fetching brand transactions:',
            brandTransactionsResponse.error,
          );
          throw brandTransactionsResponse.error;
        }

        if (brandNameResponse.error) {
          console.error('Error fetching brand name:', brandNameResponse.error);
          throw brandNameResponse.error;
        }

        setBrandTransactions(brandTransactionsResponse.data);
        setBrandName(brandNameResponse.data.name);
      } else {
        const brandTransactionsResponse = await supabase
          .schema('admin_backend')
          .from('brand_transactions')
          .select('*')
          .order('created_at', { ascending: false });

        if (brandTransactionsResponse.error) {
          console.error(
            'Error fetching brand transactions:',
            brandTransactionsResponse.error,
          );
          throw brandTransactionsResponse.error;
        }

        setBrandTransactions(brandTransactionsResponse.data);
      }
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      snackbar.handleSnackbarOpen(errorCast.message, 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout
      title={merchantId ? brandName : 'All Brand Transactions'}
      actions={
        <Button
          // component={Link}
          // to="./new"
          onClick={() => {
            dialog.handleDialogOpen(
              <BrandTransactionDialog getData={getData} />,
              'New Brand Transaction',
            );
          }}
          startIcon={<GridAddIcon />}
          size="small"
          variant="contained">
          New Transaction
        </Button>
      }>
      <DataGrid columns={columns} rows={brandTransactions} />
      <Outlet />
    </PageBaseLayout>
  );
}
